import type { IconData } from '@stacksjs/iconify-core'

export const signalAlt3: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6 23H2a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1\" opacity=\".25\"/><path fill=\"currentColor\" d=\"M14 23h-4a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M22 23h-4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v20a1 1 0 0 1-1 1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default signalAlt3
